import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import get from 'lodash/get'
import {withRouter} from 'react-router'
import orderBy from 'lodash/orderBy'
import Header from './Header'
import Markets from './Markets'

@withRouter
export default class List extends React.Component {
  static propTypes = {
    markets: PropTypes.array,
    selectedCurrency: PropTypes.string,
    toggleMenu: PropTypes.func,
    router: PropTypes.object,
    searchBarText: PropTypes.string
  }

  state = {
    order: {
      name: '',
      type: 'desc'
    }
  }

  selectMarket = (event, marketCode) => {
    this.props.router.push(`/exchange/${marketCode}`)
    this.props.toggleMenu(event)
  }

  filterMarkets = () => {
    const {searchBarText, markets, selectedCurrency} = this.props
    if (searchBarText) {
      return markets.filter(market => market.code.includes(searchBarText))
    }
    if (selectedCurrency) {
      return markets.filter(market => market.secondaryCurrency.code === selectedCurrency)
    }
    return markets
  }

  orderBy = attr => {
    const {name, type} = this.state.order
    const opposite = {
      asc: 'desc',
      desc: 'asc'
    }
    const order = name === attr ? opposite[type] : 'desc'
    this.setState({order: {name: attr, type: order}})
  }

  formattedMarkets() {
    const formattedMarkets = this.filterMarkets().map(market => {
      const {lastTrade, secondaryCurrency, mainCurrency, currentStats} = market
      return {
        ...market,
        price: get(lastTrade, 'price', 0) / Math.pow(10, secondaryCurrency.units),
        variation: get(currentStats, 'variation', 0),
        volume: get(currentStats, 'volume', 0) / Math.pow(10, mainCurrency.units)
      }
    })
    const {name, type} = this.state.order
    return orderBy(formattedMarkets, name, type)
  }

  render() {
    return (
      <div className={styles.container}>
        <Header order={this.state.order} orderBy={this.orderBy} />
        <Markets selectMarket={this.selectMarket} markets={this.formattedMarkets()} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/index.js